import React from 'react';
import styled from 'styled-components';

export default styled(props => {
  const { error, ...rest } = props;
  if (error) {
    return <div {...rest} children={error} />;
  }
  return null;
})`
  color: red;
  font-weight: 700;
  text-align: center;
  margin-top: 1rem;
`;
